module.exports = __webpack_public_path__ + "img/excel.6f407c35.svg";